import { Component, OnInit, signal, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { BaseModal } from 'shared/abstract/base-modal';
import { Tab } from 'shared/interfaces/tab.interface';
import { EventBusService } from 'shared/services/event-bus.service';
import { unsubscribeFromAll } from 'shared/util/unsubscribeFromAll';
import { SupplierUserEditBasicComponent } from '../supplier-user-edit-basic/supplier-user-edit-basic.component';
import { SupplierUserEditListingAccessComponent } from '../supplier-user-edit-listing-access/supplier-user-edit-listing-access.component';
import { SupplierUserEditPermissionsComponent } from '../supplier-user-edit-permissions/supplier-user-edit-permissions.component';

@Component({
    selector: 'app-edit-supplier-user',
    templateUrl: './supplier-user-edit.component.html',
    styleUrls: ['./supplier-user-edit.component.scss'],
    standalone: false,
})
//TODO: extract general edit-component
export class SupplierUserEditComponent extends BaseModal implements OnInit, OnDestroy {
    public data!: any;
    private subscriptions: { [key: string]: Subscription | undefined } = {};
    public tabs!: Tab[];

    private _selectedTabIndex = 0;
    public mainButtonLabel = signal<string | undefined>(undefined);
    private tabRouteMapping = ['basic', 'permissions', 'listingAccess'];

    constructor(private eventBusService: EventBusService) {
        super();
    }

    ngOnInit(): void {
        this.tabs = [
            {
                label: 'users.supplierUsers.edit.basic.label',
                component: SupplierUserEditBasicComponent,
                data: this.data,
            },
            {
                label: 'users.supplierUsers.edit.permissions.label',
                component: SupplierUserEditPermissionsComponent,
                data: this.data,
            },
            {
                label: 'users.supplierUsers.edit.listingAccess.label',
                component: SupplierUserEditListingAccessComponent,
                data: this.data,
            },
        ];

        this.subscriptions.closeModalEvent = this.eventBusService
            .getObservableForEventStream('closeUserModal')
            .subscribe((data) => this.closeModalInstance(data));
    }

    ngOnDestroy() {
        unsubscribeFromAll(this.subscriptions);
    }

    public modalMainButtonAction() {
        this.eventBusService.dispatch('modalMainButtonAction', this.tabRouteMapping[this._selectedTabIndex]);
    }

    public closeModal() {
        this.closeModalInstance(undefined);
    }

    selectTab(event: any) {
        this._selectedTabIndex = event;
        this.mainButtonLabel.set(`users.supplierUsers.edit.buttonLabel.${this.tabRouteMapping[this._selectedTabIndex]}`);
    }
}
